import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../components/HomeView.vue'
import FaqView from '../components/FaqView.vue'
import DocView from '../components/DocView.vue'
import ChangelogView from '../components/ChangelogView.vue'
import NotFoundView from '../components/NotFoundView.vue'

const SITE_URL = 'https://hypnomaker.com'

const routes = [
  {
    path: '/',
    component: HomeView,
    meta: {
      title: 'HypnoMaker: Create Custom Hypnosis & PMV Videos',
      description: 'HypnoMaker is a desktop app for creating custom hypnosis, PMV, sissy, bimbo, and affirmation videos, with voiceover, beat-synced cuts, music, and more. Free to start.',
    },
  },
  {
    path: '/faq',
    component: FaqView,
    meta: {
      title: 'FAQ · HypnoMaker',
      description: 'Frequently asked questions about HypnoMaker: customization, audio and binaural beats, pricing, platforms, and support.',
    },
  },
  {
    path: '/docs',
    component: DocView,
    meta: {
      title: 'Documentation · HypnoMaker',
      description: 'The complete HypnoMaker user guide: Hypno Mode, PMV Mode, three-panel mode, 102 scripts, male and female TTS voices, source audio mixing, overlays, filters, transitions, and output settings.',
    },
  },
  {
    path: '/changelog',
    component: ChangelogView,
    meta: {
      title: 'Changelog · HypnoMaker',
      description: 'What\'s new in HypnoMaker: latest features, improvements, and bug fixes.',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFoundView,
    meta: {
      title: 'Page Not Found · HypnoMaker',
      description: 'This page does not exist.',
      noindex: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, top: 80 }
    return { top: 0 }
  },
})

function setMeta(selector, attr, value) {
  const el = document.head.querySelector(selector)
  if (el) el.setAttribute(attr, value)
}

router.afterEach((to) => {
  const title = to.meta.title || 'HypnoMaker'
  const description = to.meta.description || ''
  const url = SITE_URL + (to.path === '/' ? '/' : to.path)

  document.title = title
  setMeta('meta[name="description"]', 'content', description)
  setMeta('link[rel="canonical"]', 'href', url)
  setMeta('meta[property="og:title"]', 'content', title)
  setMeta('meta[property="og:description"]', 'content', description)
  setMeta('meta[property="og:url"]', 'content', url)
  setMeta('meta[name="twitter:title"]', 'content', title)
  setMeta('meta[name="twitter:description"]', 'content', description)
  setMeta('meta[name="robots"]', 'content', to.meta.noindex ? 'noindex, nofollow' : 'index, follow')
})

export default router
